/**
 * @desc getSameRoleUserNos
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Set<string>>;
export function request(
  params: API.appCenter.appFacadeImpl.getSameRoleUserNos.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/roleUserRelation/same`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
